export function addCurrent(tags) {
    return {
        type: 'ADD_CURRENT',
        tags,
    }
}
